import { useMutation } from '@tanstack/react-query';

import { useInvalidateIntegrationByAccountId } from '@/entities/integrations';
import {
  IUpdateIntegrationsListDataDto,
  IUpdateIntegrationsListResponseDto,
  updateIntegrationsByAccountId,
} from '@/shared/api/integrations';
import { useNotifications } from '@/shared/ui/Notifications';

export interface IUpdateMutationData extends IUpdateIntegrationsListDataDto {
  account_id: string;
}

export function useUpdateIntegration() {
  const invalidateIntegrationsList = useInvalidateIntegrationByAccountId();
  const { addNotification } = useNotifications();

  const updateIntegrationMutation = useMutation({
    mutationFn: ({ account_id, ...updateValues }: IUpdateMutationData) =>
      updateIntegrationsByAccountId(account_id, updateValues),
    onSuccess: async () => {
      await invalidateIntegrationsList();
    },
    onError: (error) => {
      addNotification({
        title: error.message,
        caption: error?.data?.details,
      });
    },
  });

  const updateIntegration = async (
    data: IUpdateMutationData,
    onChanged?: () => void
  ): Promise<IUpdateIntegrationsListResponseDto> => {
    return updateIntegrationMutation.mutateAsync(data, {
      onSuccess: onChanged,
    });
  };

  return { updateIntegration, ...updateIntegrationMutation };
}
